import React from 'react';
import {connect} from 'react-redux';
import ApiActions from 'go/actions/api';
import {API_TASK_ASSIGN_POST_SUCCESS, API_TASK_UNASSIGN_SUCCESS} from 'common/types';
import _ from 'lodash';

export class AssignSubmitWrapper extends React.Component {
  handleSubmit = (...args) => {
    const {taskId, token, assignTask, unassignTask} = this.props;
    return unassignTask(taskId, token)
      .then((res) => {
        if (res && res.type === API_TASK_UNASSIGN_SUCCESS) {
          return assignTask(taskId, token);
        }
      })
      .then((res) => {
        if (res && res.type === API_TASK_ASSIGN_POST_SUCCESS) {
          return this.props.handleSubmit(...args);
        } else {
          console.error(
            'Failed to assign task to user, not attempting to complete task.'
          );
        }
      });
  };

  render() {
    return this.props.children(this.handleSubmit);
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    assignTask: (id, token) => {
      const action = ApiActions.tasks.assignTask(id, token);
      const res = dispatch(action);
      return res;
    },
    unassignTask: (id, token) => {
      const action = ApiActions.tasks.unassignTask(token, id);
      const res = dispatch(action);
      return res;
    },
  };
};

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    taskId: _.get(state, 'dynamicComponent.context.workflowTask.task.id'),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AssignSubmitWrapper);
